import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-bs-menu-dots",
  "use": "icon-fi-bs-menu-dots-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-bs-menu-dots\"><circle cx=\"21.517\" cy=\"12.066\" r=\"2.5\" /><circle cx=\"12\" cy=\"12\" r=\"2.5\" /><circle cx=\"2.5\" cy=\"12\" r=\"2.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-bs-menu-dots.svg
// module id = JAx8
// module chunks = 63